var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HubspotConnection_1;
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { Connection, ConnectionType } from './connection';
const schema = {
    $id: 'urn:wisepipe-common-connection:HubspotConnection',
    type: 'object',
    properties: {},
    required: []
};
let HubspotConnection = HubspotConnection_1 = class HubspotConnection extends Connection {
    constructor(connectionID, name, source) {
        super(connectionID, ConnectionType.Hubspot, name, source);
        JSON.validate(this, HubspotConnection_1);
    }
};
HubspotConnection = HubspotConnection_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ConnectionType.Hubspot)
], HubspotConnection);
export { HubspotConnection };
//# sourceMappingURL=hubspotConnection.js.map